import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'XML' },
    { value: 2, label: 'JSON' },
  ],
});
